import { create } from "zustand";

/**
 * GlobalStore - Manages global application state
 *
 * Usage:
 * ```tsx
 * import { useGlobalStore } from "@/stores/GlobalStore";
 *
 * const { sidebar } = useGlobalStore();
 * const { isSidebarCompact, setIsSidebarCompact, toggleSidebarCompact } = sidebar;
 * ```
 */
interface GlobalState {
  sidebar: {
    isSidebarCompact: boolean;
    setIsSidebarCompact: (isCompact: boolean) => void;
    toggleSidebarCompact: () => void;
  };
}

export const useGlobalStore = create<GlobalState>((set) => ({
  sidebar: {
    isSidebarCompact: true,
    setIsSidebarCompact: (isCompact: boolean) =>
      set((state) => ({ sidebar: { ...state.sidebar, isSidebarCompact: isCompact } })),
    toggleSidebarCompact: () =>
      set((state) => ({
        sidebar: { ...state.sidebar, isSidebarCompact: !state.sidebar.isSidebarCompact },
      })),
  },
}));
